import axios from "axios";

// Get base URL from environment or fallback
const baseURL = process.env.REACT_APP_BASE_URL_PRAKASHAK;

export const Version = {
  version: "1.6.4",
};

// Dynamically determine environment status
export const networkStatus = baseURL?.includes("tatvagyan.in")
  ? "Test 🔴"
  : baseURL?.includes("localhost")
  ? "Local ⚪"
  : baseURL?.includes("co.in")
  ? "Staging 🟠"
  : "Production 🟢";

export default axios.create({
  baseURL,
});
